import { Injectable } from '@angular/core';
import { HttpHelper } from '../../http-helper';
import { Observable } from 'rxjs';
import { EpicsResponse } from '../models/epic.model';

@Injectable({providedIn: 'root'})
export class EpicService {

  constructor(private httpHelper: HttpHelper) {
  }

  getEpics(): Observable<EpicsResponse> {
    return this.httpHelper.getRequest("/jira/epics")
  }
}
